<template>
  <div class="internal-history-listing" v-if="getPermission('history:view')">
    <v-container fluid class="custom-bthrust-style">
      <v-container class="pr-0">
        <v-layout class="justify-end">
          <div class="mx-2 my-2">
            <v-menu
              v-if="false"
              v-model="datePicker"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  dense
                  filled
                  flat
                  placeholder="Date Range"
                  hide-details
                  solo
                  :disabled="pageLoading"
                  v-on:click:clear="clearFilter('dates')"
                  clearable
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :value="formattedDate"
                  color="cyan"
                ></v-text-field>
              </template>
              <v-date-picker
                color="cyan"
                range
                :disabled="pageLoading"
                v-on:change="getHistories"
                v-model="dates"
              ></v-date-picker>
            </v-menu>
            <DateRangePicker
              placeholder="Data Range"
              v-model="dates"
              v-on:update:model-value="getHistories()"
              v-on:click:clear="clearFilter('dates')"
            ></DateRangePicker>
          </div>
          <div class="mr-2 my-2">
            <v-text-field
              v-model.trim="filter.search"
              v-on:click:clear="clearFilter('search')"
              clearable
              dense
              filled
              flat
              placeholder="Search"
              hide-details
              solo
              :disabled="pageLoading"
              color="cyan"
              @keydown.enter="getHistories"
              @keydown.tab="getHistories"
            ></v-text-field>
          </div>
          <div class="ml-2 my-2">
            <v-tooltip top content-class="custom-top-tooltip">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  class="custom-bold-button white--text"
                  color="cyan"
                  tile
                  :disabled="pageLoading"
                  v-on:click="getHistories"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>Search</span>
            </v-tooltip>
          </div>
        </v-layout>
      </v-container>
      <v-simple-table fixed-header height="67vh">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="simple-table-th">Description</th>
              <!--     <th width="100" class="simple-table-th">Remark</th> -->
              <th width="200" class="simple-table-th">IP Address</th>
              <th width="200" class="simple-table-th">Created Time</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="histories.length > 0">
              <tr
                v-for="(history, index) in histories"
                :key="index"
                :class="{
                  'custom-border-top': index == 0,
                  'orange_lighten-5': index % 2 == 0,
                }"
              >
                <td class="simple-table-td">
                  <template v-if="history.added_by">
                    <span class="font-weight-700">{{
                      history.added_by.display_name
                    }}</span>
                  </template>
                  &nbsp;
                  <!-- <span v-html="history.description"></span> -->
                  <read-more
                    class=""
                    more-str="Read more"
                    :text="history.description || '<em>No description</em>'"
                    link="#"
                    less-str="Read less"
                    :max-chars="150"
                  >
                  </read-more>
                </td>
                <td class="simple-table-td" width="100" v-if="false">
                  <p v-if="history.remark" class="mt-3">
                    <!-- <span class="font-weight-700">Remark: </span> -->
                    &nbsp;&nbsp;&nbsp;<v-tooltip
                      bottom
                      content-class="custom-bottom-tooltip"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          style="height: 32px !important"
                          class="custom-bold-button"
                          depressed
                          icon
                          v-on:click="openRemarkHistory(history)"
                          color="green white--text"
                          v-if="history.remark"
                          ><v-icon>mdi-comment-multiple-outline</v-icon></v-btn
                        >
                      </template>
                      <span>Remark</span>
                    </v-tooltip>
                  </p>
                  <p v-else class="mt-3">
                    <em class="text-muted"> no remark</em>
                  </p>
                </td>
                <td class="simple-table-td" width="200">
                  {{ history.ip_address }}
                </td>
                <td class="simple-table-td" width="200">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        v-if="history.created_at"
                        class="mx-2 my-1 custom-grey-border"
                        color="blue-grey darken-1"
                        text-color="white"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-avatar left>
                          <v-icon>mdi-clock-outline</v-icon>
                        </v-avatar>
                        <p class="m-0 custom-nowrap-ellipsis">
                          {{ history.created_at }}
                        </p>
                      </v-chip>
                    </template>
                    <p class="m-0 custom-nowrap-ellipsis">
                      {{ formatDate(history.added_at) }}
                      {{ formatDateStartedNew(history.added_at) }}
                    </p>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-else>
              <template v-if="pageLoading">
                <tr v-for="row in 4" :key="row">
                  <td>
                    <v-skeleton-loader
                      type="text"
                      class="custom-skeleton table-rows-text"
                    ></v-skeleton-loader>
                  </td>
                  <td>
                    <v-skeleton-loader
                      type="text"
                      class="custom-skeleton table-rows-text"
                    ></v-skeleton-loader>
                  </td>
                  <td>
                    <v-skeleton-loader
                      type="text"
                      class="custom-skeleton table-rows-text"
                    ></v-skeleton-loader>
                  </td>
                </tr>
              </template>
              <tr v-else-if="!pageLoading">
                <td colspan="4">
                  <p
                    class="m-0 row-not-found text-center font-weight-500 font-size-16"
                  >
                    <img
                      :src="$assetURL('media/error/empty.png')"
                      class="row-not-found-image"
                    />
                    Uhh... There are no history at the moment.
                  </p>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
      <ListingFooter
        :dataLoading="pageLoading"
        :currentPage="current_page"
        :totalPages="total_pages"
        :showingFrom="showingFrom"
        :showingTo="showingTo"
        :totalRows="total_rows"
        removePage
      ></ListingFooter>
    </v-container>
    <Dialog :commonDialog="historyModal">
      <template v-slot:title> Remark </template>
      <template v-slot:body>
        <v-row>
          <v-col md="12" class="p-5 pl-5 pr-5">
            {{ historyRemark }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:action>
        <v-btn
          :disabled="pageLoading"
          class="mx-2 custom-red-border custom-bold-button red white--text"
          v-on:click="historyModal = false"
        >
          Close
        </v-btn>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { QUERY } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingFooter from "@/view/pages/partials/Listing-Footer";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import DateRangePicker from "@/view/components/DateRangePicker";
import moment from "moment-timezone";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import Dialog from "@/view/pages/partials/Dialog.vue";

export default {
  mixins: [CommonMixin],
  data() {
    return {
      dates: [],
      pageLoading: false,
      histories: new Array(),
      // histories2: [
      //   {
      //     id: 74,
      //     customer: "8",
      //     description: "Customer Persons # CP-00012 Updated",
      //     ip_address: "103.107.92.123",
      //     attributes: {
      //       id: 10,
      //       did: null,
      //       uuid: "5b1b0b8a-d414-4b74-a1ef-7eccda3d5536",
      //       title: "mr",
      //       tenant: 0,
      //       barcode: "CP-00012",
      //       default: true,
      //       added_at: "2024-08-22 16:15:23",
      //       added_by: "1",
      //       customer: "8",
      //       position: "",
      //       activated: true,
      //       full_name: "Mr. John",
      //       last_name: "",
      //       first_name: "John",
      //       updated_at: null,
      //       updated_by: "0",
      //       designation: null,
      //       display_name: "John",
      //       primary_email: "",
      //       primary_phone: "",
      //       will_notified: true,
      //     },
      //     added_by: {
      //       id: 1,
      //       display_name: "Admin",
      //       title: "Mr.",
      //       first_name: "Super",
      //       last_name: "Admin",
      //       user_email: "admin@bthrust.com",
      //       full_name: "Mr. Super Admin",
      //     },
      //     added_at: "2024-08-31 12:55:45",
      //     remark: null,
      //     created_at: "2 days ago",
      //   },
      //   {
      //     id: 65,
      //     customer: "8",
      //     description: "Customer Site Location #P-000025 is Created",
      //     ip_address: "119.56.103.253",
      //     attributes: {
      //       id: 18,
      //       type: 1,
      //       entity: "Business Thrust Pte Ltd.",
      //       barcode: "P-000025",
      //       country: "singapore",
      //       is_same: true,
      //       remarks: null,
      //       unit_no: "",
      //       added_at: "2024-08-22T08:15:23.804931Z",
      //       added_by: 1,
      //       customer: 8,
      //       latitude: "1.33374793521856",
      //       street_1: "8 UBI ROAD 2",
      //       street_2: "ZERVEX",
      //       zip_code: "408538",
      //       entity_id: 1,
      //       is_tenant: 0,
      //       longitude: "103.895524306611",
      //       property_name: "",
      //       contact_person: 10,
      //       zone_territory: null,
      //       property_address: "8 UBI ROAD 2 ZERVEX singapore 408538",
      //     },
      //     added_by: {
      //       id: 1,
      //       display_name: "Admin",
      //       title: "Mr.",
      //       first_name: "Super",
      //       last_name: "Admin",
      //       user_email: "admin@bthrust.com",
      //       full_name: "Mr. Super Admin",
      //     },
      //     added_at: "2024-08-22 16:15:23",
      //     remark: null,
      //     created_at: "1 week ago",
      //   },
      //   {
      //     id: 64,
      //     customer: "8",
      //     description: "Contact Person #CP-00012 is created",
      //     ip_address: "119.56.103.253",
      //     attributes: {
      //       id: 10,
      //       did: null,
      //       uuid: "5b1b0b8a-d414-4b74-a1ef-7eccda3d5536",
      //       title: "mr",
      //       barcode: "CP-00012",
      //       default: true,
      //       added_at: "2024-08-22T08:15:23.578621Z",
      //       added_by: 1,
      //       customer: 8,
      //       position: "",
      //       full_name: "Mr. John",
      //       last_name: "",
      //       first_name: "John",
      //       designation: null,
      //       display_name: "John",
      //       primary_email: "",
      //       primary_phone: "",
      //       will_notified: true,
      //     },
      //     added_by: {
      //       id: 1,
      //       display_name: "Admin",
      //       title: "Mr.",
      //       first_name: "Super",
      //       last_name: "Admin",
      //       user_email: "admin@bthrust.com",
      //       full_name: "Mr. Super Admin",
      //     },
      //     added_at: "2024-08-22 16:15:23",
      //     remark: null,
      //     created_at: "1 week ago",
      //   },
      //   {
      //     id: 63,
      //     customer: "8",
      //     description: "Customer #C-000011 is created",
      //     ip_address: "119.56.103.253",
      //     attributes: {
      //       id: 8,
      //       uen: "",
      //       city: "",
      //       group: "Commercial",
      //       phone: "",
      //       state: "",
      //       entity: "Business Thrust Pte Ltd.",
      //       barcode: "C-000011",
      //       country: "",
      //       primary: true,
      //       website: "",
      //       added_at: "2024-08-22T08:15:23.571251Z",
      //       added_by: 1,
      //       category: "SATCOM",
      //       group_id: "1",
      //       can_login: 1,
      //       entity_id: 1,
      //       company_fax: null,
      //       postal_code: "",
      //       reffered_by: 0,
      //       unit_number: "",
      //       company_name: "abc jhbkjbjasdsa pte",
      //       company_type: "company",
      //       display_name: "abc jhbkjbjasdsa pte",
      //       company_email: "",
      //       security_code: "Q6XAEFHU",
      //       address_line_1: "",
      //       address_line_2: "",
      //       category_color: "#FF0000FF",
      //       company_number: "",
      //       customer_remark: null,
      //       sap_customer_no: null,
      //       client_reminders: 0,
      //       cust_vend_ref_no: null,
      //       client_follow_up_emails: 0,
      //       print_email_on_work_order: 0,
      //     },
      //     added_by: {
      //       id: 1,
      //       display_name: "Admin",
      //       title: "Mr.",
      //       first_name: "Super",
      //       last_name: "Admin",
      //       user_email: "admin@bthrust.com",
      //       full_name: "Mr. Super Admin",
      //     },
      //     added_at: "2024-08-22 16:15:23",
      //     remark: null,
      //     created_at: "1 week ago",
      //   },
      // ],
      filter: {
        search: null,
      },
      per_page: 10,
      current_page: 1,
      offset: 0,
      total_pages: 0,
      total_rows: 0,
      historyRemark: null,
      historyModal: false,
    };
  },
  components: {
    ListingFooter,
    Dialog,
    DateRangePicker,
  },
  props: {
    isCurrentUser: {
      required: false,
      type: Number,
      default: 0,
    },
    type: {
      required: true,
      type: String,
      default: "",
    },
    type_id: {
      required: false,
      type: Number,
      default: 0,
    },
  },
  watch: {
    type_id() {
      let type_id = this.lodash.toSafeInteger(this.type_id);
      if (type_id > 0) {
        this.getHistories();
      }
    },
  },
  methods: {
    openRemarkHistory(history) {
      let _this = this;
      _this.historyRemark = history?.remark;
      _this.historyModal = true;
    },
    formatDateStartedNew(param) {
      return moment(param).format("hh:mm A");
    },
    clearFilter(field) {
      const _this = this;
      switch (field) {
        case "search":
          _this.filter.search = null;
          break;
        case "dates":
          _this.dates = [];
          break;
      }
      _this.getHistories();
    },
    getHistories() {
      const _this = this;

      if (_this.lodash.isEmpty(_this.dates) === false) {
        if (moment(_this.dates[0]).isAfter(_this.dates[1])) {
          ErrorEventBus.$emit(
            "update:error",
            InitializeError("End Date must be after Start Date.")
          );
          return false;
        }
      }
      _this.pageLoading = true;
      _this.histories = [];
      _this.$store
        .dispatch(QUERY, {
          url: "history",
          data: {
            type: _this.type,
            type_id: _this.type_id,
            per_page: _this.per_page,
            current_page: _this.current_page,
            search: _this.filter.search,
            start_date: _this.dates[0] || null,
            end_date: _this.dates[1] || null,
            is_current_user: _this.isCurrentUser,
          },
        })
        .then(({ data }) => {
          _this.offset = data.offset;
          _this.histories = data.rows;
          _this.total_pages = Math.ceil(data.total_rows / data.per_page);
          _this.current_page = data.current_page;
          _this.total_rows = data.total_rows;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination");
  },
  mounted() {
    const _this = this;
    /* let type_id = _this.lodash.toSafeInteger(_this.type_id);
    if (type_id > 0) {
      _this.getHistories();
    } */
    _this.getHistories();

    PaginationEventBus.$on("update:pagination", (param) => {
      _this.current_page = param;
      _this.getHistories();
    });
  },
  computed: {
    showingFrom() {
      return this.lodash.isEmpty(this.histories) === false
        ? this.offset + 1
        : 0;
    },
    showingTo() {
      return this.offset + (this.histories ? this.histories.length : 0);
    },
  },
};
</script>
